<div class="dashboard-content">
  <app-sidebar></app-sidebar>

  <div class="dashboard-main">
    <div class="dashboard-map-area">
      <div class="meter meter-battery" aria-hidden="true">
        <div class="meter-fill" style="height: 75%;">
          <span class="meter-value">75%</span>
        </div>
      </div>

      <div class="map-container">
        <app-map [mode]="'live'"></app-map>
      </div>

      <div class="meter meter-range" aria-hidden="true">
        <div class="meter-fill" style="height: 57.142857%;">
          <span class="meter-value">40 km</span>
        </div>
      </div>
    </div>

    <div class="dashboard-chat-area">
      <app-ai-chat></app-ai-chat>
    </div>
  </div>
</div>

<div class="below-map-content">
  <app-last-ride-card></app-last-ride-card>
  <app-weather></app-weather>
</div>